/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupscreate1Inputs */

const en_groupscreate1 = /** @type {(inputs: Groupscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create group`)
};

const de_groupscreate1 = /** @type {(inputs: Groupscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erstellen`)
};

/**
* | output |
* | --- |
* | "Create group" |
*
* @param {Groupscreate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupscreate1 = /** @type {((inputs?: Groupscreate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupscreate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupscreate1(inputs)
	return de_groupscreate1(inputs)
});
export { groupscreate1 as "groupsCreate" }